import { handleGetRequest } from "./GetTemplate";
import { handlePostRequest } from "./PostTemplate";

export const CURRENCY_OPTIONS = [
    { label: "USD", value: "usd" },
    { label: "JMD", value: "jmd" },
];

// Any authenticated staff member can read this - used to preview a JMD
// amount's USD equivalent before submitting a payment.
export const fetchCurrentExchangeRate = () => handleGetRequest("/exchange-rate/current");

// Admin-only: live lookup used only to pre-fill the "set rate" form.
export const fetchSuggestedExchangeRate = () => handleGetRequest("/exchange-rate/suggested");

export const fetchExchangeRateHistory = () => handleGetRequest("/exchange-rate/history");

export const setExchangeRate = (dispatch, rate, suggestedRate) =>
    dispatch(handlePostRequest({ rate, suggestedRate }, "/exchange-rate", true, true));
